import React, { useState, useEffect, useCallback } from 'react';
import '../../../styles/Toast.css';

const Icons = {
    success: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M9 12l2 2 4-4" />
        </svg>
    ),
    info: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
    ),
    warning: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
    ),
    error: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
    ),
    close: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
};

const Toast = ({ id, type, title, message, duration, onRemove }) => {
    const [isExiting, setIsExiting] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [progress, setProgress] = useState(100);
    const [remainingTime, setRemainingTime] = useState(duration);

    const handleClose = useCallback(() => {
        setIsExiting(true);
        setTimeout(() => {
            onRemove(id);
        }, 300);
    }, [id, onRemove]);

    useEffect(() => {
        if (isPaused) return;

        const startTime = Date.now();
        const initialRemaining = remainingTime;

        const interval = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const newRemaining = initialRemaining - elapsed;

            if (newRemaining <= 0) {
                clearInterval(interval);
                handleClose();
            } else {
                setProgress((newRemaining / duration) * 100);
                setRemainingTime(newRemaining);
            }
        }, 16);

        return () => clearInterval(interval);
    }, [isPaused, remainingTime, duration, handleClose]);

    return (
        <div
            className={`toast toast--${type} ${isExiting ? 'toast--exiting' : ''}`}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            role="alert"
            aria-live="polite"
        >
            <div className="toast__icon">{Icons[type]}</div>

            <div className="toast__content">
                <div className="toast__title">{title}</div>
                <div className="toast__message">{message}</div>
            </div>

            <button className="toast__close" onClick={handleClose} aria-label="Close notification">
                {Icons.close}
            </button>

            <div className="toast__progress-track">
                <div className="toast__progress-bar" style={{ width: `${progress}%` }} />
            </div>
        </div>
    );
};

export default Toast;